import { Stack, Box, Button, Typography } from "@mui/material";
import { DataGridPro, GridColDef } from "@mui/x-data-grid-pro";
import SaveOutlinedIcon from "@mui/icons-material/SaveOutlined";
import SecondPositiveST from "./SecondPositiveST";
import SecondNegetiveST from "./SecondNegetiveST";
import { useState } from "react";
import SecondSaveChangesAi from "./SecondSaveChangesAi";

// --- rows (your JSON data) ---
const rows = [
  {
    id: 1,
    searchTerm: "UK sports betting",
    matchType: "Broad",
    lastSeen: "21/07/25",
    imp: "213,456",
    Clicks: "12,000",
    Cost: "1,999",
    PositiveST: "12",
    NegativeST: "10",
  },
  {
    id: 2,
    searchTerm: "best betting uk",
    matchType: "Broad",
    lastSeen: "01/07/25",
    imp: "12,000",
    Clicks: "1,200",
    Cost: "899",
    PositiveST: "12",
    NegativeST: "10",
  },
  {
    id: 3,
    searchTerm: "sport gambling",
    matchType: "Broad",
    lastSeen: "08/07/25",
    imp: "300",
    Clicks: "90",
    Cost: "120",
    PositiveST: "12",
    NegativeST: "10",
  },
  {
    id: 4,
    searchTerm: "betting",
    matchType: "Exact",
    lastSeen: "13/07/25",
    imp: "7,800",
    Clicks: "1,050",
    Cost: "650",
    PositiveST: "12",
    NegativeST: "10",
  },
  {
    id: 5,
    searchTerm: "online betting sites",
    matchType: "Broad",
    lastSeen: "17/07/25",
    imp: "10,400",
    Clicks: "2,000",
    Cost: "1,250",
    PositiveST: "12",
    NegativeST: "10",
  },
];

const SecondTableAi = () => {
  const [openDialog, setOpenDialog] = useState(false);
  const [selectedRow, setSelectedRow] = useState<any>(null);
  const [openNegativeST, setOpenNegativeST] = useState(false);
  const [OpensaveTerm, setOpensaveTerm] = useState(false);

  const handleOpenDialog = (row: any) => {
    setSelectedRow(row);
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setSelectedRow(null);
    setOpenDialog(false);
  };

  const handleOpenNegativeST = (row: any) => {
    setSelectedRow(row);
    setOpenNegativeST(true);
  };

  const handleCloseNegativeST = () => {
    setSelectedRow(null);
    setOpenNegativeST(false);
  };

  const handleOpenSaveTerm = (row: any) => {
    setSelectedRow(row);
    setOpensaveTerm(true);
  };

  const handleCloseSaveTerm = () => {
    setSelectedRow(null);
    setOpensaveTerm(false);
  };
  // --- Define columns ---
  const columns: GridColDef[] = [
    { field: "searchTerm", headerName: "Search Term", flex: 1, minWidth: 160 },
    { field: "matchType", headerName: "Match Type", flex: 0.6, minWidth: 110 },
    { field: "lastSeen", headerName: "Last Seen", flex: 0.6, minWidth: 110 },
    { field: "imp", headerName: "IMP", flex: 0.6, minWidth: 110 },

    // 🔹 New fields
    { field: "Clicks", headerName: "Clicks", flex: 0.6, minWidth: 110 },
    { field: "Cost", headerName: "Cost", flex: 0.6, minWidth: 110 },
    {
      field: "PositiveST",
      headerName: "Positive ST",
      flex: 0.6,
      minWidth: 110,
      renderCell: (params) => (
        <Typography
          variant="body2"
          color="secondary"
          sx={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => handleOpenDialog(params.row)}
        >
          {params.value}
        </Typography>
      ),
    },
    {
      field: "NegativeST",
      headerName: "Negative ST",
      flex: 0.6,
      minWidth: 110,
      renderCell: (params) => (
        <Typography
          variant="body2"
          color="secondary"
          sx={{ cursor: "pointer", textDecoration: "underline" }}
          onClick={() => handleOpenNegativeST(params.row)}
        >
          {params.value}
        </Typography>
      ),
    },
  ];

  return (
    <>
      {/* DataGrid */}
      <Stack flexDirection={"column"} alignItems={"flex-end"} gap={1}>
        <Box sx={{ width: "100%", marginTop: 2, display: "grid" }}>
          <DataGridPro
            sx={{
              "& .MuiDataGrid-cell:focus, & .MuiDataGrid-cell:focus-within": {
                outline: "none",
              },
              "& .MuiDataGrid-columnHeader:focus, & .MuiDataGrid-columnHeader:focus-within":
                { outline: "none" },
              "& .MuiDataGrid-cellEmpty": {
                width: "auto",
                overflow: "hidden",
                textOverflow: "ellipsis",
              },

              // row selection only once
              "& .MuiDataGrid-row.Mui-selected": {
                backgroundColor: "rgba(156, 39, 176, 0.08) !important",
                "&:hover": {
                  backgroundColor: "rgba(156, 39, 176, 0.16) !important",
                },
              },

              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedLeft": {
                backgroundColor: "#f0def3 !important",
              },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedLeft":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },

              // pinned RIGHT
              "& .MuiDataGrid-row.Mui-selected .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#f0def3 !important",
                },
              "& .MuiDataGrid-row.Mui-selected:hover .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#e6d6e9ff !important",
                },
              // make pinned cells transparent → let row bg show through
              "& .MuiDataGrid-cell--pinnedLeft, & .MuiDataGrid-cell--pinnedRight":
                {
                  backgroundColor: "#ffffff",
                },

              // remove extra blue tint on single cell select
              "& .MuiDataGrid-cell.Mui-selected": {
                backgroundColor: "inherit !important",
              },

              "& .MuiCheckbox-root": {
                color: "#9c27b0 !important",
              },
              "& .MuiCheckbox-root.Mui-checked": {
                color: "#9c27b0",
              },
              border: "none",
            }}
            density="compact"
            hideFooter
            pagination={false}
            rows={rows}
            columns={columns}
            disableColumnMenu
            disableColumnFilter
            disableColumnReorder
            sortingOrder={["asc", "desc"]}
            isCellEditable={() => false}
            disableRowSelectionOnClick
          />
        </Box>
        <Button
          variant="contained"
          color="secondary"
          endIcon={<SaveOutlinedIcon />}
          onClick={handleOpenSaveTerm}
        >
          Save changes
        </Button>
      </Stack>
      <SecondPositiveST
        open={openDialog}
        rowData={selectedRow}
        onClose={handleCloseDialog}
      />
      <SecondNegetiveST
        open={openNegativeST}
        rowData={selectedRow}
        onClose={handleCloseNegativeST}
      />
      <SecondSaveChangesAi
        open={OpensaveTerm}
        rowData={selectedRow}
        onClose={handleCloseSaveTerm}
      />
    </>
  );
};

export default SecondTableAi;
